import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";
import HumanAgentRepository from "../../repositories/human_agent.repository";

interface props {
    humanAgentRepository: HumanAgentRepository;
}

@injectable()
class DownloadAgentResumeUseCase {
    private humanAgentRepository: HumanAgentRepository;

    constructor({ humanAgentRepository }: props) {
        this.humanAgentRepository = humanAgentRepository;
    }

    public call = async (_:{agentId: string, startDate?: Date, endDate?: Date}): Promise<Either<ErrorEntity, void>> => {
        return this.humanAgentRepository.downloadResumeAgent(_);
    }
}

export default DownloadAgentResumeUseCase;

export const DownloadAgentResumeUseCaseName = "DownloadAgentResumeUseCase";